<template>
    <div class="d-flex flex-column h-100">
        <header class="navbar-expand-lg">
            <HeaderOptions/>

            <div class="spot-rates-container">
                <nav class="navbar-chart d-print-none">
                    <div class="container-xxl">
                        <div class="d-flex flex-column flex-lg-row flex-xl-wrap justify-content-xl-center justify-content-xl-between align-items-xl-center spot-rates-component">
                            <SpotRates />
                        </div>
                    </div>
                </nav>
            </div>
            <nav class="navbar-1">
                <div class="container-xxl">
                    <div class="row align-items-center" id="header-row">
                        <div class="col-3 d-none d-lg-block">
                            <NuxtLinkLocale class="navbar-brand mb-4 mb-lg-0 mx-auto mx-lg-0" to="index"/>
                        </div>
                        <div v-if="!isCompleteRoute" class="col-3 d-none d-lg-block order-lg-1 mt-3 mt-lg-0">
                            <BuySellToggler/>
                        </div>
                        <div class="col col-auto ms-auto order-1 order-lg-2">
                            <ul class="navbar-nav flex-row align-items-center justify-content-between justify-content-lg-end">
                                <li class="d-block d-lg-none">
                                    <NuxtLink class="navbar-brand me-0"
                                              :title="settingsStore.get('setting.site_name')"
                                              :to="localePath({ name: 'index' })"/>
                                </li>
                                <li class="nav-item ms-auto d-lg-inline-block">
                                    <Watchlist/>
                                </li>
                                <li class="nav-item">
                                    <ProfileMenu/>
                                </li>
                                <li class="mobile-icon-spacing ms-0 ms-lg-3">
                                    <TradingCart/>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </nav>
<!--            <div class="col-12 col-lg-6 order-2 order-lg-1 d-print-none mt-3 mt-lg-0 d-flex align-items-center text-uppercase">-->
<!--                <div class="flex-grow-1 d-flex justify-content-center justify-content-lg-start gap-2">-->

<!--                </div>-->
<!--                <div class="d-block d-lg-none ms-auto">-->
<!--                </div>-->
<!--            </div>-->
        </header>

        <main class="pb-5 flex-shrink-0">
            <div class="full-height">
                <slot/>
            </div>
        </main>

        <footer class="bg-footer mt-auto pb-2 pb-xl-4 d-print-none">
            <Footer/>
        </footer>

        <GlobalModals/>
    </div>
</template>

<script setup>
import {onMounted} from "vue";
import {useSettingsStore} from '~/stores/SettingsStore';
import {useLocaleStore} from '~/stores/LocaleStore';
import { useLocalePath } from '#imports';

const localePath = useLocalePath();

const settingsStore = useSettingsStore();

const isCompleteRoute = computed(() => useRoute().path.includes('/complete/'));

const HeaderOptions = defineAsyncComponent(() => import('~/components/Layout/Spm/HeaderOptions.vue'));
const Footer = defineAsyncComponent(() => import('~/components/Layout/Spm/Footer.vue'));
const ProfileMenu = defineAsyncComponent(() => import("~/components/ProfileMenu.vue"));
const GlobalModals = defineAsyncComponent(() => import("~/components/Modals/GlobalModals.vue"));
const Watchlist = defineAsyncComponent(() => import("~/components/Watchlist.vue"));
const TradingCart = defineAsyncComponent(() => import("~/components/Cart/TradingCart.vue"));
const BuySellToggler = defineAsyncComponent(() => import("~/components/SPM/BuySellToggler.vue"));
const SpotRates = defineAsyncComponent(() => import('../components/SPM/SpotRates.vue'));

useHead({
    htmlAttrs: {
        lang: useLocaleStore().getLanguage()
    },
    bodyAttrs: {
        class: 'h-100',
    },
});

onMounted(() => {
    gtm.push(settingsStore.datalayer);
});
</script>
